import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody,
  Label, FormFeedback, Input, Form, NavItem, NavLink, TabContent, TabPane,
  FormGroup, Badge, Button, Spinner, Nav,
  UncontrolledTooltip
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import classnames from "classnames";

// Import Breadcrumb & Toastr
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// Redux (Mevcut yapıyı koruyoruz)
import { useDispatch } from "react-redux";

// --- API YAPILANDIRMASI ---
const API_BASE = "https://dlaviapi.stechomeyazilim.info";
const UPLOAD_ENDPOINT = "https://dlaviadmin.stechomeyazilim.info/Uploads/uploads.php";
const FILE_BASE_URL = "https://dlaviadmin.stechomeyazilim.info/Uploads/";

const API_URLS = {
  listQuestions: `${API_BASE}/Question?$expand=Question_SpeechBuilder,Question_Type&$orderby=ID asc`, 
  listTypes:     `${API_BASE}/Question_Type`,
  addQuestion:    `${API_BASE}/Question`,
  updateQuestion: (id) => `${API_BASE}/Question(${id})`,
  deleteQuestion: `${API_BASE}/Question`, 
  addSpeechBuilder: `${API_BASE}/Question_SpeechBuilder`,
  updateSpeechBuilder: (id) => `${API_BASE}/Question_SpeechBuilder(${id})`
};

const ContactsList = props => {
  document.title = "Soru Yönetimi | DLApro";

  const dispatch = useDispatch();
  
  // --- STATE TANIMLARI ---
  const [questionList, setQuestionList] = useState([]);
  const [typesList, setTypesList] = useState([]);
  
  // Modal ve Edit State
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  
  // Yükleme Durumları
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadingAudio, setUploadingAudio] = useState(false);

  // Tab State'leri
  const [activeCategoryTab, setActiveCategoryTab] = useState("ALL"); // Ana Sayfa Sekmeleri (Genel, Resim vb.)
  const [activeModalTab, setActiveModalTab] = useState(1); // Modal içi sekmeler (Genel, SB Basic, SB Plus)

  // --- VERİ ÇEKME ---
  useEffect(() => {
    fetchTypes();
    fetchQuestions();
  }, []);

  const fetchTypes = async () => {
    try {
      const res = await axios.get(API_URLS.listTypes);
      setTypesList(res.data.value || []); 
    } catch (error) {
      console.error("Soru tipleri çekilemedi:", error);
    }
  };

  const fetchQuestions = async () => {
    try {
      const res = await axios.get(API_URLS.listQuestions);
      // Sort işlemi: Soru numarasına veya ID'ye göre sıralayalım
      setQuestionList(res.data.value);
    } catch (error) {
      console.error("Sorular çekilemedi:", error);
    }
  };

  // --- KATEGORİ FİLTRELEME ---
  // Kullanıcı üstteki sekmelerden birine tıkladığında listeyi filtreler
  const filteredData = useMemo(() => {
    if (activeCategoryTab === "ALL") return questionList;
    return questionList.filter(q => q.Question_Type_ID === activeCategoryTab);
  }, [questionList, activeCategoryTab]);

  // --- DOSYA YÜKLEME ---
  const handleFileUpload = async (e, fieldName, setLoadingState) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoadingState(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
        const res = await axios.post(UPLOAD_ENDPOINT, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (res.data && res.data.status) {
            validation.setFieldValue(fieldName, res.data.url);
            showToast("Başarılı", "Dosya yüklendi.", true);
        } else {
            showToast("Hata", res.data.message || "Yükleme başarısız.", false);
        }
    } catch (error) {
        console.error("Upload hatası:", error);
        showToast("Hata", "Dosya yüklenirken sunucu hatası oluştu.", false);
    } finally {
        setLoadingState(false);
    }
  };

  // --- FORMIK & YUP ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ID: (editData && editData.ID) || 0,
      QuestionNumber: (editData && editData.QuestionNumber) || "",
      Question_Title: (editData && editData.Question_Title) || "",
      Question_Info: (editData && editData.Question_Info) || "",
      Question_Url: (editData && editData.Question_Url) || "",
      Question_Mp3Url: (editData &&  editData.Question_Mp3Url) || "",
      // Eğer belirli bir kategori sekmesindeysek, yeni eklerken o kategoriyi otomatik seç
      Question_Type_ID: (editData && editData.Question_Type_ID) || (activeCategoryTab !== "ALL" ? activeCategoryTab : ""),
      Is_Free: (editData && editData.Is_Free) || false,
      Sort: (editData && editData.Sort) || 0,

      // Speech Builder Verileri (Dizi içinden ilki alınır)
      SB_Sample_Basic: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Sample_Basic) || "",
      SB_Structure_Basic: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Structure_Basic) || "",
      SB_Vocabulary_Basic: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Vocabulary_Basic) || "",

      SB_Sample_Plus: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Sample_Plus) || "",
      SB_Structure_Plus: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Structure_Plus) || "",
      SB_Vocabulary_Plus: (editData?.Question_SpeechBuilder?.[0]?.Question_SpeechBuilder_Vocabulary_Plus) || "",
    },
    validationSchema: Yup.object({
      QuestionNumber: Yup.string().required("Soru numarası/kodu zorunludur."),
      Question_Title: Yup.string().required("Soru başlığı zorunludur."),
      Question_Type_ID: Yup.number().required("Soru tipi seçilmelidir."),
    }),
    onSubmit: (values) => {
      handleFinalSubmit(values);
    },
  });

  // --- KAYDET / GÜNCELLE ---
  const handleFinalSubmit = async (values) => {
    // 1. Question Tablosu Payload
    const questionPayload = {
      QuestionNumber: values.QuestionNumber,
      Question_Title: values.Question_Title,
      Question_Info: values.Question_Info,
      Question_Url: values.Question_Url,
      Question_Mp3Url: values.Question_Mp3Url,
      Question_Type_ID: parseInt(values.Question_Type_ID),
      Is_Free: values.Is_Free,
      Sort: values.Sort
    };

    console.log("questionPayload123",questionPayload)
    const currentSbID = (editData?.Question_SpeechBuilder?.[0]?.ID) || null;

    try {
      let activeQuestionID = null;

      if (isEdit) {
        await axios.patch(API_URLS.updateQuestion(values.ID), questionPayload);
        activeQuestionID = values.ID; 
      } else {
        const resQ = await axios.post(API_URLS.addQuestion, questionPayload);
        activeQuestionID = resQ.data.value[0].ID; 
      }

      if (!activeQuestionID) throw new Error("Soru ID alınamadı.");

      // 2. Speech Builder Payload (Varsa)
      const hasSbData = values.SB_Sample_Basic || values.SB_Vocabulary_Basic || values.SB_Sample_Plus;

      if (hasSbData) {
        const sbPayload = {
          Question_ID: activeQuestionID, 
          Question_SpeechBuilder_Sample_Basic: values.SB_Sample_Basic,
          Question_SpeechBuilder_Structure_Basic: values.SB_Structure_Basic,
          Question_SpeechBuilder_Vocabulary_Basic: values.SB_Vocabulary_Basic,
          Question_SpeechBuilder_Sample_Plus: values.SB_Sample_Plus,
          Question_SpeechBuilder_Structure_Plus: values.SB_Structure_Plus,
          Question_SpeechBuilder_Vocabulary_Plus: values.SB_Vocabulary_Plus
        };

        if (currentSbID) {
          await axios.patch(API_URLS.updateSpeechBuilder(currentSbID), sbPayload);
        } else {
          await axios.post(API_URLS.addSpeechBuilder, sbPayload);
        }
      }

      showToast("Başarılı", isEdit ? "Soru güncellendi." : "Soru eklendi.", true);
      toggle();
      fetchQuestions();

    } catch (error) {
      console.error("Kaydetme hatası:", error);
      showToast("Hata", "İşlem başarısız.", false);
    }
  };

  // --- SİLME ---
  const onDeleteConfirm = async () => {
    if (contactToDelete && contactToDelete.ID) {
      try {
        await axios.delete(`${API_URLS.deleteQuestion}(${contactToDelete.ID})`);
        showToast("Başarılı", "Soru silindi.", true);
        fetchQuestions();
      } catch (error) {
        showToast("Hata", "Silme işlemi başarısız.", false);
      }
    }
    setDeleteModal(false);
  };

  // --- YARDIMCILAR ---
  const showToast = (title, message, isSuccess) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 3000 };
    if (isSuccess) toastr.success(message, title);
    else toastr.error(message, title);
  };

  const toggle = () => {
    if (modal) {
      setEditData(null);
      setIsEdit(false);
      validation.resetForm();
      setActiveModalTab(1);
    }
    setModal(!modal);
  };

  const handleEditClick = (row) => {
    setEditData(row);
    setIsEdit(true);
    setModal(true);
  };

  const handleDeleteClick = (row) => {
    setContactToDelete(row);
    setDeleteModal(true);
  };

  // --- TABLO KOLONLARI ---
  const columns = useMemo(
    () => [
      {
        Header: "Kod",
        accessor: "QuestionNumber",
        Cell: ({ value }) => <span className="fw-bold text-primary">{value}</span>
      },
      {
        Header: "Başlık",
        accessor: "Question_Title",
        Cell: ({ value }) => (value && value.length > 40 ? value.substring(0, 40) + "..." : value) || "-"
      },
      {
        Header: "Medya",
        accessor: "Question_Url",
        Cell: ({ value, row }) => (
            <div className="d-flex gap-1">
                {value && <i className="mdi mdi-image text-info font-size-18" title="Resim Var"></i>}
                {row.original.Question_Mp3Url && <i className="mdi mdi-music text-warning font-size-18" title="Ses Var"></i>}
                {(!value && !row.original.Question_Mp3Url) && <span className="text-muted">-</span>}
            </div>
        )
      },
      {
        Header: "Tip",
        accessor: "Question_Type_ID", 
        Cell: ({ value }) => {
            const type = typesList.find(t => t.ID === value);
            return type ? <Badge color="info" className="font-size-12">{type.Question_Type_Title}</Badge> : value;
        }
      },
      {
        Header: "Durum",
        accessor: "Is_Free",
        Cell: ({ value }) => (value ? <Badge color="success">Ücretsiz</Badge> : <Badge color="dark">Premium</Badge>),
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
          <div className="d-flex gap-3">
            <Link to="#" className="text-success" onClick={() => handleEditClick(cellProps.row.original)}>
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">Düzenle</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-danger" onClick={() => handleDeleteClick(cellProps.row.original)}>
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    [typesList]
  );


  const handleUserClicks = () => {
    setIsEdit(false);
    toggle();
  };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={onDeleteConfirm} onCloseClick={() => setDeleteModal(false)} />
      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="İçerik Yönetimi" breadcrumbItem="Soru Bankası" />
          
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* --- KATEGORİ SEKMELERİ (AYRI SAYFA GİBİ ÇALIŞIR) --- */}
                  <Nav pills className="nav-justified mb-3 bg-light p-2 rounded">
                    <NavItem>
                        <NavLink 
                            className={classnames({ active: activeCategoryTab === "ALL" })}
                            onClick={() => setActiveCategoryTab("ALL")}
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                        >
                            TÜM SORULAR
                        </NavLink>
                    </NavItem>
                    {typesList.map(type => (
                        <NavItem key={type.ID}>
                            <NavLink 
                                className={classnames({ active: activeCategoryTab === type.ID })}
                                onClick={() => setActiveCategoryTab(type.ID)}
                                style={{ cursor: "pointer", fontWeight: "bold" }}
                            >
                                {type.Question_Type_Title.toUpperCase()}
                            </NavLink>
                        </NavItem>
                    ))}
                  </Nav>

                  <TableContainer
                    columns={columns}
                    data={filteredData}
                    isGlobalFilter={true}
                    isAddBlog={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* --- SORU EKLEME / DÜZENLEME MODALI --- */}
          <Modal isOpen={modal} toggle={toggle} size="xl" centered scrollable>
            <ModalHeader toggle={toggle} tag="h4">
              {isEdit ? "Soruyu Güncelle" : "Yeni Soru Oluştur"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                
                {/* MODAL İÇİ ADIMLAR (WIZARD) */}
                <div className="wizard clearfix mb-4">
                    <div className="steps clearfix">
                        <ul>
                            <NavItem className={classnames({ current: activeModalTab === 1 })}>
                                <NavLink className={classnames({ active: activeModalTab === 1 })} onClick={() => setActiveModalTab(1)}>
                                    <span className="number">1.</span> Soru & Medya
                                </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ current: activeModalTab === 2 })}>
                                <NavLink className={classnames({ active: activeModalTab === 2 })} onClick={() => setActiveModalTab(2)}>
                                    <span className="number">2.</span> Speech Builder (Basic)
                                </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ current: activeModalTab === 3 })}>
                                <NavLink className={classnames({ active: activeModalTab === 3 })} onClick={() => setActiveModalTab(3)}>
                                    <span className="number">3.</span> Speech Builder (Plus)
                                </NavLink>
                            </NavItem>
                        </ul>
                    </div>
                </div>

                <TabContent activeTab={activeModalTab}>
                  {/* TAB 1: GENEL BİLGİLER & MEDYA */}
                  <TabPane tabId={1}>
                    <Row>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label>Soru Kodu (Benzersiz)</Label>
                                <Input name="QuestionNumber"
                                    onChange={validation.handleChange} onBlur={validation.handleBlur}
                                    value={validation.values.QuestionNumber}
                                    invalid={!!(validation.touched.QuestionNumber && validation.errors.QuestionNumber)}
                                />
                                <FormFeedback>{validation.errors.QuestionNumber}</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                             <FormGroup className="mb-3">
                                <Label>Soru Tipi</Label>
                                <Input type="select" name="Question_Type_ID"
                                    onChange={validation.handleChange} onBlur={validation.handleBlur}
                                    value={validation.values.Question_Type_ID}
                                    invalid={!!(validation.touched.Question_Type_ID && validation.errors.Question_Type_ID)}
                                >
                                    <option value="">Seçiniz</option>
                                    {typesList.map(type => (
                                        <option key={type.ID} value={type.ID}>{type.Question_Type_Title}</option>
                                    ))}
                                </Input>
                                <FormFeedback>{validation.errors.Question_Type_ID}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                             <FormGroup className="mb-3">
                                <Label>Soru Metni / Başlığı</Label>
                                <Input type="textarea" rows={3} name="Question_Title"
                                    onChange={validation.handleChange} value={validation.values.Question_Title}
                                    invalid={!!(validation.touched.Question_Title && validation.errors.Question_Title)}
                                />
                                <FormFeedback>{validation.errors.Question_Title}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    {/* RESİM YÜKLEME */}
                    <Card className="border border-light bg-light mb-3">
                        <CardBody>
                            <h6 className="card-title mb-3"><i className="mdi mdi-image text-primary"></i> Soru Görseli</h6>
                            <Row>
                                <Col md={8}>
                                    <Input name="Question_Url"
                                        placeholder="Görsel URL (Otomatik dolar)"
                                        onChange={validation.handleChange}
                                        value={validation.values.Question_Url}
                                        disabled
                                    />
                                </Col>
                                <Col md={4}>
                                    <div style={{ position: 'relative', overflow: 'hidden' }}>
                                        <Button color="primary" block disabled={uploadingImage}>
                                            {uploadingImage ? <Spinner size="sm" /> : <><i className="mdi mdi-cloud-upload"></i> Görsel Seç & Yükle</>}
                                        </Button>
                                        <Input type="file" 
                                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                            onChange={(e) => handleFileUpload(e, 'Question_Url', setUploadingImage)}
                                            accept="image/*"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {validation.values.Question_Url && (
                                <div className="mt-2 text-center">
                                    <img src={FILE_BASE_URL + validation.values.Question_Url} alt="Önizleme" style={{maxHeight: '150px', borderRadius: '5px'}} />
                                </div>
                            )}
                        </CardBody>
                    </Card>

                    {/* SES YÜKLEME */}
                    <Card className="border border-light bg-light mb-3">
                        <CardBody>
                            <h6 className="card-title mb-3"><i className="mdi mdi-microphone text-danger"></i> Soru Ses Kaydı</h6>
                            <Row>
                                <Col md={8}>
                                    <Input name="Question_Mp3Url"
                                        placeholder="MP3 URL (Otomatik dolar)"
                                        onChange={validation.handleChange}
                                        value={validation.values.Question_Mp3Url}
                                        disabled
                                    />
                                </Col>
                                <Col md={4}>
                                    <div style={{ position: 'relative', overflow: 'hidden' }}>
                                        <Button color="danger" block disabled={uploadingAudio}>
                                            {uploadingAudio ? <Spinner size="sm" /> : <><i className="mdi mdi-music-note-plus"></i> MP3 Seç & Yükle</>}
                                        </Button>
                                        <Input type="file" 
                                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                            onChange={(e) => handleFileUpload(e, 'Question_Mp3Url', setUploadingAudio)}
                                            accept=".mp3,audio/*"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {validation.values.Question_Mp3Url && (
                                <div className="mt-2">
                                    <audio controls src={FILE_BASE_URL + validation.values.Question_Mp3Url} style={{ width: '100%' }} />
                                </div>
                            )}
                        </CardBody>
                    </Card>

                    <Row>
                        <Col md={12}>
                             <FormGroup className="mb-3">
                                <Label>Ekstra Bilgi / Not (Opsiyonel)</Label>
                                <Input type="textarea" rows={2} name="Question_Info"
                                    onChange={validation.handleChange} value={validation.values.Question_Info}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                             <FormGroup className="mb-3">
                                <Label>Sıralama (Sort Order)</Label>
                                <Input type="number" name="Sort"
                                    onChange={validation.handleChange} value={validation.values.Sort}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6} className="d-flex align-items-center">
                             <FormGroup check className="mt-3 ms-2">
                                <Label check>
                                    <Input type="checkbox" name="Is_Free"
                                        onChange={validation.handleChange} checked={validation.values.Is_Free}
                                    /> Bu soru Ücretsiz (Free) olarak işaretlensin
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                  </TabPane>

                  {/* TAB 2: SPEECH BUILDER - BASIC */}
                  <TabPane tabId={2}>
                    <div className="alert alert-info">
                        <i className="mdi mdi-school"></i> Başlangıç seviyesi (Basic) kullanıcılar için ipuçları.
                    </div>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">1. Sample Answer (Örnek Cevap)</Label>
                            <Input type="textarea" rows={4} name="SB_Sample_Basic" placeholder="Basic seviye örnek cevap..."
                                onChange={validation.handleChange} value={validation.values.SB_Sample_Basic}
                            />
                        </Col>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">2. Structure (Kalıplar)</Label>
                            <Input type="textarea" rows={4} name="SB_Structure_Basic" placeholder="Kullanılabilecek gramer yapıları..."
                                onChange={validation.handleChange} value={validation.values.SB_Structure_Basic}
                            />
                        </Col>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">3. Vocabulary (Kelimeler)</Label>
                            <Input type="textarea" rows={4} name="SB_Vocabulary_Basic" placeholder="Anahtar kelimeler..."
                                onChange={validation.handleChange} value={validation.values.SB_Vocabulary_Basic}
                            />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* TAB 3: SPEECH BUILDER - PLUS */}
                  <TabPane tabId={3}>
                    <div className="alert alert-warning">
                        <i className="mdi mdi-star"></i> İleri seviye (Plus) kullanıcılar için gelişmiş ipuçları.
                    </div>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">1. Sample Answer (Örnek Cevap - Gelişmiş)</Label>
                            <Input type="textarea" rows={4} name="SB_Sample_Plus"
                                onChange={validation.handleChange} value={validation.values.SB_Sample_Plus}
                            />
                        </Col>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">2. Structure (Kalıplar - Gelişmiş)</Label>
                            <Input type="textarea" rows={4} name="SB_Structure_Plus"
                                onChange={validation.handleChange} value={validation.values.SB_Structure_Plus}
                            />
                        </Col>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">3. Vocabulary (Kelimeler - Gelişmiş)</Label>
                            <Input type="textarea" rows={4} name="SB_Vocabulary_Plus"
                                onChange={validation.handleChange} value={validation.values.SB_Vocabulary_Plus}
                            />
                        </Col>
                    </Row>
                  </TabPane>
                </TabContent>

                <div className="d-flex justify-content-between mt-4 border-top pt-3">
                    <Button color="light" onClick={toggle}>Vazgeç</Button>
                    <div className="d-flex gap-2">
                        {activeModalTab > 1 && (
                            <Button color="secondary" onClick={() => setActiveModalTab(activeModalTab - 1)}>
                                <i className="mdi mdi-arrow-left"></i> Geri
                            </Button>
                        )}
                        {activeModalTab < 3 ? (
                            <Button color="primary" onClick={() => setActiveModalTab(activeModalTab + 1)}>
                                İleri <i className="mdi mdi-arrow-right"></i>
                            </Button>
                        ) : (
                            <Button type="submit" color="success" className="px-4">
                                <i className="mdi mdi-content-save"></i> {isEdit ? "Değişiklikleri Kaydet" : "Soruyu Oluştur"}
                            </Button>
                        )}
                    </div>
                </div>

              </Form>
            </ModalBody>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);